// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"hashtag"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 15.5L3 15.5M21 8.5L3 8.5M16.5 3L14.5 21M9.5 3L7.5 21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const HashtagIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'hashtag',
    ref,
    icon: element,
  },
));

HashtagIcon.displayName = 'HashtagIcon';

export default HashtagIcon;
